import { render } from "./ArticleGallery.vue?vue&type=template&id=21f7232f"
import script from "./ArticleGallery.vue?vue&type=script&lang=js"
export * from "./ArticleGallery.vue?vue&type=script&lang=js"

import "./ArticleGallery.vue?vue&type=style&index=0&id=21f7232f&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__